// @flow

import { submitForm } from 'common/form'
import { pendingActions } from 'common/pending-actions'
import { enrollAndRedirectToOlympiads } from 'common/redirect'
import { sentTaskCompleteDrugoeDelo } from 'common/sent-tasks-drugoe-delo'

import { OLYMPIAD_IDS } from '../../../constants'

export const submitFormOlymp = async (event: Event) => {
  await submitForm(event)

  const target = event.target
  if (!(target instanceof HTMLElement)) {
    return
  }

  const tagId = Number(target.getAttribute('data-tag'))
  const grade = ((target.querySelector('[data-name="Grade"]'): any): HTMLSelectElement).value
  const discipline = String(target.getAttribute('data-discipline'))

  await pendingActions.addTag(tagId)

  await sentTaskCompleteDrugoeDelo()

  enrollAndRedirectToOlympiads(OLYMPIAD_IDS[discipline][grade])
}
